export default __webpack_public_path__ + "static/media/no-calendar.33a3d62b.jpg";